import React, { useRef, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import validate from "../../../utils/validate";
import "../styles.scss";

import LogoSmall from "../../../assets/images/logo-small.png";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import DescriptionIcon from "@material-ui/icons/Description";
import Logo from "../../../assets/images/logo_transparent.png";
import { Button, CssBaseline, TextField, Link, Paper, Grid, Typography, Divider } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import Copyright from "../Copyright";

import { AllProps } from "./LoginContainer";
import { getHeaders, setHeaders } from "../../../redux/utils";

function Alert(props: AlertProps) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Login = (props: AllProps) => {
	const history = useHistory();
	const { loadingError } = props.auth;
	const { storeSession } = props;

	const emailRef: any = useRef("");
	const passwordRef: any = useRef("");

	const [credentials, setCredentials] = useState({
		email: "",
		password: "",
		emailConfirmationCode: "",
	});
	const [errors, setErrors] = useState({} as any);

	useEffect(() => {
		if (props.auth.user) {
			Auth.currentSession()
				.then((r: any) => {
					storeSession(r);
				})
				.catch((e) => {
					console.error(e);
				});
		}
	}, [props.auth.user, storeSession]);

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		setCredentials({
			...credentials,
			[name]: value,
		});
	};
	const handleLogin = (e: any) => {
		e.preventDefault();
		const validation = validate("login", credentials);
		setErrors({
			...errors,
			email: validation.email,
			password: validation.password,
		});
		if (validation.email === undefined && validation.password === undefined) {
			doLogin();
		}
	};
	const handleFederatedLogIn = (e: any) => {
		e.preventDefault();
		Auth.federatedSignIn({ customProvider: "azure-ad" }).catch((e: any) => {
			console.log(e);
		});
	};
	const doLogin = () => {
		const escapeEmails = [
			"PAhayas581@990ys.com",
			"Aryano2009@hotmail.com",
			"C_D_Melanson@hotmail.com",
			"Education@upstatetraining.com",
			"Phylwon@aol.com",
			"President@hta-ca.org",
			"Townsvillepig@gmail.com",
		];
		const email = escapeEmails.find((email: string) => email.toLowerCase() === emailRef.current.value.toLowerCase());
		const values = {
			username: email ? escapeEmails[escapeEmails.indexOf(email)] : emailRef.current.value.toLowerCase(),
			password: passwordRef.current.value,
		};
		emailRef.current.value = "";
		passwordRef.current.value = "";

		props.login(values);
	};

	// In case the user did not confirm his email earlier
	const confirmRegister = (e: any) => {
		e.preventDefault();
		const userData = {
			Username: props.showConfirmEmail,
			ConfirmationCode: credentials.emailConfirmationCode,
		};

		props.confirmSignUp(userData).then(() => {
			props.login({ username: props.showConfirmEmail, password: credentials.password }).then((r: any) => {
				history.push("/dashboard");
				Auth.currentSession().then((r: any) => {
					localStorage.setItem("jwt", r.accessToken.jwtToken);
					localStorage.setItem("jwt", r.idToken.jwtToken);
					setHeaders({
						"Content-Type": "application/json",
						Authorization: `Bearer ${r.accessToken.jwtToken}`,
						IdToken: r.idToken.jwtToken,
					});
					props.storeSession(r).then(() => {});
				});
			});
		});
	};

	return (
		<div>
			<Grid container component="main" className="root login">
				<CssBaseline />
				<Grid item xs={12} sm={4} md={4} lg={4} className="image">
					<a href="https://gutenbergcerts.com" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "30px 30px 0" }}>
						<img style={{ width: "100%" }} src={Logo} alt="gutenberg cert logo" className="CertLogo" />
					</a>
					<div className="cert-steps" style={{ display: "none" }}>
						<Typography component="h1" variant="h5">
							Create your certificate <br /> in 3 Easy Steps
						</Typography>
						<div className="step">
							<CloudUploadIcon className="icon red" />
							<Typography component="h2">
								<b>Step 1: </b> Create/Select Template
							</Typography>
						</div>
						<div className="step">
							<MailOutlineIcon className="icon red" />
							<Typography component="h2">
								<b>Step 2: </b> Upload Recipients
							</Typography>
						</div>
						<div className="step">
							<DescriptionIcon className="icon red" />
							<Typography component="h2">
								<b>Step 3: </b> Send Certificates
							</Typography>
						</div>
					</div>
				</Grid>
				<Grid item xs={12} sm={8} md={8} lg={8} component={Paper} elevation={6} square className="flex right-side">
					<div className="paper">
						<section className="topside">
							<div className="title">
								<img src={LogoSmall} alt="small logo" className="small-logo hidden" />
								{props.showConfirmEmail ? (
									<section>
										<Typography component="h1" variant="h5">
											Confirm your email address
										</Typography>
										<Typography component="h2" className="red mt-25">
											Please enter the confirmation code recived at your email address
										</Typography>
									</section>
								) : (
									<section>
										<Typography component="h1" variant="h5">
											Log in to Your Account
										</Typography>
										<Typography component="h2">
											New to this site?
											<Link component={RouterLink} to="/register" className="red bold signup">
												Sign up
											</Link>
										</Typography>
									</section>
								)}
							</div>

							{loadingError && (
								<Alert className="banner" severity="error">
									{loadingError && loadingError.message}
								</Alert>
							)}
							{props.showConfirmEmail ? (
								<Grid container spacing={2} style={{ marginTop: "5px" }} className="form">
									<Grid item xs={12}>
										<TextField
											disabled
											error={errors.email ? true : false}
											value={props.showConfirmEmail}
											onChange={(e) => handleChange(e)}
											id={errors.email ? "outlined-error-helper-text" : "email"}
											label={errors.email ? "Error" : "Email Address"}
											helperText={errors.email ? `${errors.email}` : ""}
											variant="outlined"
											required
											fullWidth
											name="email"
											autoComplete="email"
										/>
									</Grid>
									<Grid item xs={12}>
										<TextField
											value={credentials.emailConfirmationCode}
											onChange={(e) => handleChange(e)}
											id={errors.email ? "outlined-error-helper-text" : "emailConfirmationCode"}
											label={errors.email ? "Error" : "Email Confirmation Code"}
											variant="outlined"
											required
											fullWidth
											name="emailConfirmationCode"
											autoComplete="emailConfirmationCode"
										/>
									</Grid>
									<Grid item xs={12} className="register">
										<Button type="submit" variant="contained" color="primary" onClick={(e) => confirmRegister(e)} className="submit red-bck white">
											Confirm
										</Button>
									</Grid>
								</Grid>
							) : (
								<>
									<form className="form" noValidate>
										<TextField
											error={errors.email ? true : false}
											value={credentials.email}
											onChange={(e) => handleChange(e)}
											inputRef={emailRef}
											id={errors.email ? "outlined-error-helper-text" : "email"}
											label={errors.email ? "Error" : "Email Address"}
											helperText={errors.email ? `${errors.email}` : ""}
											variant="outlined"
											margin="normal"
											required
											fullWidth
											name="email"
											autoComplete="email"
										/>
										<TextField
											error={errors.password ? true : false}
											value={credentials.password}
											inputRef={passwordRef}
											onChange={(e) => handleChange(e)}
											id={errors.password ? "outlined-error-helper-text" : "password"}
											label={errors.password ? "Error" : "Password"}
											helperText={errors.password ? `${errors.password}` : ""}
											variant="outlined"
											margin="normal"
											required
											fullWidth
											name="password"
											type="password"
											autoComplete="current-password"
										/>
										{/* <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Remember me"
                  /> */}
										<div className="actions login">
											<Link component={RouterLink} to="reset-password" className="red bold forgotpass">
												I forgot my password
											</Link>
										</div>
									</form>
									<Button
										type="submit"
										variant="contained"
										className="loginButton red-bck"
										style={{ maxWidth: "fit-content", marginInline: "auto", marginBottom: "20px" }}
										onClick={(e) => handleLogin(e)}
										disabled={props.auth.isLoading}
									>
										{props.auth.isLoading ? "Loading ..." : "Log In"}
									</Button>
									<Divider />
									<Button
										variant="contained"
										// color="primary"
										className="azureLoginButton"
										onClick={(e) => handleFederatedLogIn(e)}
										disabled={props.auth.isLoading}
									>
										{props.auth.isLoading ? "Loading ..." : "Log in with Azure AD"}
									</Button>
								</>
							)}
						</section>
						<Grid container justifyContent="flex-end" className="copyright hidden">
							<Copyright />
						</Grid>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default Login;
